import * as React from "react";

import { Button, ControlGroup, FormGroup, InputGroup } from "@blueprintjs/core";
import { format } from "date-fns";
import ReCAPTCHA from "react-google-recaptcha";
import { WithTranslation, withTranslation } from "react-i18next";
import { IGiftCardByCode } from "~/graphql/queries/giftCard/giftCardByCode";
import { shopConfig } from "~/helpers/shopConfig";
import { StyledCallout as Callout } from "~/layouts/StyledCallout";
import { StyledCard as Card } from "~/layouts/StyledCard";
import styled from "~/styled";
import GiftCard from "./GiftCard";
import GiftCardNotFound from "./GiftCardNotFound";

export interface IFormState {
  giftCardNumber: string;
}

interface IProps {
  giftCardNumber: string;
  giftCardNotFound: string;
  showWarning: boolean;
  giftCardData: IGiftCardByCode | undefined;
  errorMessage: string;
  onSubmit: () => any;
  onChange: (formState: Partial<IFormState>) => any;
  onRecaptchaChange: ((token: string | null) => void) | undefined;
}

const Form = styled.form`
  margin-top: 24px;
`;

const ReCAPTCHAContainer = styled.div`
  margin-bottom: 12px;
`;

class GiftCardBalanceChecker extends React.Component<IProps & WithTranslation> {
  public render() {
    const {
      t,
      showWarning,
      giftCardData,
      errorMessage,
      giftCardNumber,
      giftCardNotFound
    } = this.props;

    return (
      <React.Fragment>
        <Callout intent="none" title={t("header.title")}>
          <div>{t("header.description")}</div>
        </Callout>

        <Card>
          {t("cardForm.description")}

          <Form method="post" onSubmit={this.handleSubmit}>
            <FormGroup label={t("cardForm.label")}>
              <ControlGroup fill={true}>
                <InputGroup
                  value={giftCardNumber}
                  onChange={this.handleChange("giftCardNumber")}
                />

                <Button
                  type="submit"
                  intent="primary"
                  disabled={giftCardNumber === ""}
                >
                  {t("cardForm.submit")}
                </Button>
              </ControlGroup>
            </FormGroup>

            <ReCAPTCHAContainer>
              <ReCAPTCHA
                hl={shopConfig.language}
                sitekey="6LdWg5QbAAAAAAPybZ537eckCLDWmuHRWLouhypG"
                onChange={this.props.onRecaptchaChange}
              />
            </ReCAPTCHAContainer>
          </Form>

          {showWarning && (
            <Callout intent="warning" title={t("cardForm.errors.recaptcha")} />
          )}

          {giftCardData && !errorMessage && (
            <GiftCard
              balance={giftCardData.giftCardByCode.balance}
              maskedCode={giftCardData.giftCardByCode.maskedCode}
              initialValue={giftCardData.giftCardByCode.initialValue}
              expiresOn={
                giftCardData.giftCardByCode.expiresOn
                  ? format(
                      new Date(giftCardData.giftCardByCode.expiresOn),
                      "dd-MM-yyyy"
                    )
                  : null
              }
            />
          )}

          {errorMessage && (
            <GiftCardNotFound giftCardNotFound={giftCardNotFound} />
          )}
        </Card>
      </React.Fragment>
    );
  }

  private handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    this.props.onSubmit();
  };

  private handleChange = (key: "giftCardNumber") => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.props.onChange({
      [key]: event.currentTarget.value.toUpperCase()
    });
  };
}

export default withTranslation("giftcard")(GiftCardBalanceChecker);



// WEBPACK FOOTER //
// ./src/components/GiftCard/GiftCardBalanceChecker.tsx